import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!q) return;
    api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setResults(r.data.results));
  }, [q]);

  return (
    <div className="max-w-screen-xl mx-auto p-6 lg:p-8 space-y-4" data-testid="search-page">
      <h1 className="font-outfit font-bold text-3xl tracking-tight text-stone-900">Resultados para "{q}"</h1>
      <p className="text-sm text-stone-500">{results.length} coincidencias</p>

      <Card className="border-stone-200 bg-white divide-y divide-stone-100">
        {results.length === 0 ? (
          <p className="p-6 text-sm text-stone-500">Sin resultados.</p>
        ) : results.map((r, i) => {
          const link = r.type === "Recepción" ? `/trazabilidad?lote=${r.label}`
            : r.type === "Producción" ? `/trazabilidad?lote=${r.label.split(" / ")[0]}`
            : r.type === "Venta" ? `/trazabilidad?lote=${r.label}`
            : r.type === "Cliente" ? "/clientes"
            : "#";
          return (
            <Link key={i} to={link} className="block p-4 hover:bg-stone-50">
              <div className="flex justify-between items-center">
                <div>
                  <div className="text-xs font-outfit font-semibold uppercase tracking-wider text-stone-500">{r.type}</div>
                  <div className="text-base font-medium text-[#1E3A8A] mt-0.5">{r.label}</div>
                  <div className="text-xs text-stone-500">{r.subtitle}</div>
                </div>
              </div>
            </Link>
          );
        })}
      </Card>
    </div>
  );
}
